﻿import { useNavigate } from "react-router-dom";

import classes from "../maintainers.module.scss";

import { ReactComponent as PencilSvg } from "@/assets/images/desktop/editar.svg";

const WebContentTableBody = ({ web_contents }) => {
	const navigate = useNavigate();

	return (
		<tbody>
			{web_contents &&
				web_contents.map((item, i) => {
					return (
						<tr className={`${classes.table_tr}`} key={i}>
							<td className={`${classes.table_td} ${classes.first_td}`}>
								<div className={`${classes.table_div}  ${classes.first_div}`}>{i + 1}</div>
							</td>
							<td className={`${classes.table_td}`}>
								<div className={`${classes.table_div} `}>{item.name}</div>
							</td>
							<td className={`${classes.table_td}`}>
								<div className={`${classes.table_div} `}>{item.pretitle}</div>
							</td>
							<td className={`${classes.table_td}`}>
								<div className={`${classes.table_div} `}>{item.title}</div>
							</td>
							<td className={`${classes.table_td}`}>
								<div className={`${classes.table_div} ${classes.last_div}`}>
									{item.editable ? (
										<PencilSvg className={classes.icon} onClick={() => navigate("/mantenedores/contenidos_web/editar/" + item.id)} />
									) : (
										""
									)}
								</div>
							</td>
						</tr>
					);
				})}
		</tbody>
	);
};

export default WebContentTableBody;
